export const home = {
    title1:'首页',
    title2:'部门展示',
    title3:'产品展示',
    title4:'问卷调查',
    title5:'language',
    welcome:'欢迎来到本网站',
    login:'登录/注册'
}
export const center = {
    title1:'关于我们',
    title2:'部门展示',
    title3:'产品展示',
    more:'更多',
    titlex:'问卷调查'
}

export const bottom = {
    address:'地址',
    email:'邮箱',
    phone:'电话',
    Postal :'邮编'
}
export const paper = {
    submit:'确认提交',
    btn:'参加活动',
    tips:'提交成功'
}
export const login = {
    title:'账号登陆',
    email:'邮箱',
    pwd:'密码',
    titlel:'账号注册',
    titler:'忘记密码',
    btn:'登录'
}
export const register = {
    title:'账号注册',
    code:'验证码',
    email:'邮箱',
    pwd:'密码',
    pwd2:'确认密码',
    titlel:'账号登录',
    titler:'忘记密码',
    btn:'注册',
    codeTips:'获取验证码'
}
export const forgot = {
    title:'忘记密码',
    code:'验证码',
    email:'邮箱',
    pwd:'旧密码',
    pwd2:'新密码',
    titlel:'账号登录',
    titler:'忘记密码',
    btn:'确认修改',
    codeTips:'获取验证码'
}
export const active = {
    tips:'张先生通过调查问卷获得了100美元的奖励！',
    title1:'立即签到',
    title2:'完成登录任务',
    title3:'获得50美金奖励',
    title4:'立即参与',
    title22:'完成签到任务',
    title23:'完成升级任务',
    popup1:'注册成功，获得100美金奖励;快去完成其他任务吧！',
    popup2:'今日签到领取20积分',
    popup3:'很抱歉，当前会员等级不够，无法进入相应任务，请立即联系客服！',
    popup1Btn:'我知道了',
    popup2Btn:'我知道了',
    popup3Btn:'联系客服',
}


// WEBPACK FOOTER //
// ./src/i18n/zh.js